import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { TEAM_OVERVIEW_URL } from 'constants/urls';
import { useSnackbar } from 'utilities/hooks/useSnackbar/useSnackbar';
import { useAppContext } from 'services/context';
import { useLazyGetUserDetailsQuery } from 'store/apis/userDetailsApi';
import { TOKEN_IS_NOT_PROVIDED_MESSAGE } from 'constants/errorMessages';
import { setNotificationsCountForTeamOverview } from 'components/TeamOverview/utilities';

export const LoginTokenPage = ({ match, location }) => {
  const { showError } = useSnackbar();
  const { updateIsLoggedIn } = useAppContext();
  const [getUserDetails] = useLazyGetUserDetailsQuery();

  useEffect(() => {
    const { token } = match.params;
    if (token) {
      setNotificationsCountForTeamOverview();
      localStorage.token = token;
      updateIsLoggedIn();
      getUserDetails();
    } else {
      showError(TOKEN_IS_NOT_PROVIDED_MESSAGE);
    }
  }, []);

  const params = new URLSearchParams(location.search);
  const next = params.get('next');
  const redirectTo = next && next.startsWith('/') ? next : TEAM_OVERVIEW_URL;

  return <Redirect to={redirectTo} />;
};
